// extracted by mini-css-extract-plugin
export default {"createNewGroup":"CreateGroup_createNewGroup__yRUnc","textField":"CreateGroup_textField__kiyzV","btn":"CreateGroup_btn__JMeBg","errorMessage":"CreateGroup_errorMessage__+rG8j"};